import { combineReducers } from 'redux';
import profileCompletionReducer from './profileCompletion/profileCompletionReducer';

const rootReducer = combineReducers({
  profileCompletion: profileCompletionReducer
});

export default rootReducer;
